import React from 'react';
import {useNavigate, useParams} from 'react-router';

import useYoungPersonCategories from '../Queries/useYoungPersonCategories';
import {findByRouteKey, useCanonicalRouteParams} from '../Util/routeIdentifier';
import ProItemCard from './Components/ProItemCard';
import {RESOURCE_GRID_CLASSES, ResourceNotice, ResourceQueryState} from './LoadingCard';
import {RESOURCE_TITLE_CLASSES, ResourceBreadcrumbs} from './ProCategories';

import {YOUNG_PERSON_CATEGORY_TOPIC_ICONS} from './transitionIcons';

const ProYoungPersonViewCategory = () => {
  const {data: categories, error, refetch} = useYoungPersonCategories();
  const {category: categoryKey} = useParams();
  const navigate = useNavigate();

  // Found by its slug, or by the numeric id of an address from before COM-477, which
  // becomes the slug one in place.
  const category = findByRouteKey(categories, categoryKey);
  useCanonicalRouteParams(
    {category: category?.slug},
    {resource: 'young-person-transition-category'}
  );
  const topicsWithIcons = (category?.topics ?? []).map((topic) => ({
    ...topic,
    icon: YOUNG_PERSON_CATEGORY_TOPIC_ICONS[topic.key],
  }));

  return (
    <div data-testid="pro-young-person-category">
      <ResourceBreadcrumbs
        items={[
          {label: 'Home', to: '/dashboard'},
          {label: 'Young People', to: '/young-person-categories'},
          ...(category ? [{label: category.name}] : []),
        ]}
      />
      <h1 className={`mb-6 ${RESOURCE_TITLE_CLASSES}`}>{category?.name ?? 'Young People'}</h1>
      <ResourceQueryState
        data={categories}
        error={error}
        refetch={refetch}
        label="young person resources"
        placeholderCount={9}>
        {!category ? (
          <ResourceNotice>Category not found.</ResourceNotice>
        ) : topicsWithIcons.length === 0 ? (
          <ResourceNotice>No resources are available in this category yet.</ResourceNotice>
        ) : (
          <ul className={RESOURCE_GRID_CLASSES}>
            {topicsWithIcons.map((topic) => (
              <li key={`topic-${topic.id}`} className="min-w-0">
                <ProItemCard
                  item={topic}
                  onClick={() => navigate(`item/${encodeURIComponent(topic.slug)}`)}
                />
              </li>
            ))}
          </ul>
        )}
      </ResourceQueryState>
    </div>
  );
};

export default ProYoungPersonViewCategory;
